import { useState } from "react";
import { Trash2 } from "lucide-react";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogFooter,
  AlertDialogTitle, AlertDialogDescription, AlertDialogCancel, AlertDialogAction,
} from "@/components/ui/alert-dialog";

export default function ConfirmDelete({
  onConfirm,
  testId = "delete-btn",
  title = "Delete this record?",
  description = "This action cannot be undone.",
  requireRemark = false,
}) {
  const [open, setOpen] = useState(false);
  const [remark, setRemark] = useState("");

  const confirm = () => {
    setOpen(false);
    onConfirm(remark);
    setRemark("");
  };

  return (
    <>
      <button data-testid={testId} onClick={() => setOpen(true)} className="text-slate-400 hover:text-red-600 p-1">
        <Trash2 size={16} />
      </button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent data-testid={`${testId}-dialog`}>
          <AlertDialogHeader>
            <AlertDialogTitle>{title}</AlertDialogTitle>
            <AlertDialogDescription>
              {requireRemark ? "This will be sent to an admin for approval. Add a remark (required)." : description}
            </AlertDialogDescription>
          </AlertDialogHeader>
          {requireRemark && (
            <textarea
              data-testid={`${testId}-remark`}
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
              placeholder="Reason for deletion…"
              className="w-full border border-slate-300 rounded-lg px-3 py-2 text-sm"
              rows={2}
            />
          )}
          <AlertDialogFooter>
            <AlertDialogCancel data-testid={`${testId}-cancel`}>Cancel</AlertDialogCancel>
            <AlertDialogAction
              data-testid={`${testId}-confirm`}
              disabled={requireRemark && !remark.trim()}
              onClick={confirm}
              className="bg-red-600 hover:bg-red-700 text-white disabled:opacity-40 disabled:pointer-events-none"
            >
              {requireRemark ? "Request Approval" : "Delete"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
